



































import Vue, { PropOptions } from 'vue';
import util from '@/components/util';
import * as models from '@/class/models/views/setting/users';

export default Vue.extend({
  name: 'GroupSideModal',
  components: { ...util},
  props: {
    title: String,
    selectUserID: Number,
    groupList: Array as PropOptions<models.IGroup[]>,
    groupUsedList: Array as PropOptions<models.IGroupUsed[]>,
  },
  data() {
    return {
      editGroupList: [] as models.IGroup[],
      selectList: [] as number[],
      message: '',
      newCount: 0,
    };
  },
  mounted() {
    // console.log('list', this.groupList, this.groupUsedList);
    this.editGroupList = JSON.parse(JSON.stringify(this.groupList));
    this.selectList = this.groupUsedList
      .filter((v: models.IGroupUsed) => (v.userID === this.selectUserID))
      .map((w) => (w.groupID));
    let oldNewCount = 0;
    this.editGroupList.forEach((v) => (oldNewCount = v.groupID < oldNewCount ? v.groupID : oldNewCount));
    this.newCount = oldNewCount;
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickDecide() {
      this.message = '';
      if (this.editGroupList.filter((v) => (v.name === '')).length > 0) {
        this.message = 'グループ名がない項目があります';
        return;
      }
      // Todo:同じ名称の場合のチェック
      this.$emit('select',
        {
          groupList: this.editGroupList,
          groupUsedList: this.selectList.map((v) => ({userID: this.selectUserID, groupID: v} as models.IGroupUsed)),
        },
      );
    },
    onClickAdd() {
      this.newCount--;
      this.editGroupList.push({groupID: this.newCount, name: ''} as models.IGroup);
    },
    onClickDelete(groupID: number, index: number) {
      this.message = '';
      if (this.groupUsedList.filter((v) => (v.groupID === groupID && v.userID !== this.selectUserID)).length > 0) {
        this.message = '他のユーザーで利用されているため削除できません';
      } else {
        this.selectList = this.selectList.filter((v) => (v !== groupID));
        this.editGroupList.splice(index, 1);
      }
    },
  },
});
